# Implement a sub class to create a trigger with these methods
# Required:
# - defaultTriggerName
# As needed:
# - setupModal to configure modal.config as necessary
# - generatePayload to configure the API payload as necessary
# Example Trigger
# ----------------------------------------------------------------------------
# import ResourceTrigger from './ResourceTrigger'
# class AddMemberNoteTrigger extends ResourceTrigger
#
#   @triggerConfig: ->
#     computed:
#       defaultTriggerName: -> 'add_member_note'
#
#     methods:
#       modalData: -> { note: null }
#       modalConfig: -> {}
#
#       generatePayload: ->
#         @modal.data
#
# export default AddMemberNoteTrigger
# ----------------------------------------------------------------------------

class ResourceTrigger

  @trigger: ->
    @mergeConfigs(@baseConfig(), @triggerConfig())

  @triggerConfig: -> throw('Implement TriggerConfig in your sub class')

  @baseConfig: ->
    data: ->
      triggerName: null
      component: null
      key: null
      modal:
        show: false
        data: {}
        config: {}
      payloadOptions: {}

    computed:
      opts: -> @options || {}

    methods:
      setConfig: (key, value) -> @modal.config[key] = value
      fire: (@payloadOptions = {}, modalOptions = {}) ->
        @setupTrigger()
        @modal.config = @modalConfig?() || {}
        @modal.config[k] = v for k,v of modalOptions
        @modal.data = @modalData?() || {}
        @show()

      execute: ->
        @setupTriggerName()
        @setupResourceComponent()
        @setupResourceKey()
        payload = @payloadOptions
        payload[k] = v for k, v of (@generatePayload() || {})
        @component.triggerResource @key, @triggerName, payload

      setupTrigger: ->
        # Clone the props into local data storage because props get clobbered multiple trigger on the same page.
        @setupTriggerName()
        @setupResourceComponent()
        @setupResourceKey()
        @setupModal?()

      setupTriggerName: -> @triggerName = @opts.triggerName || @defaultTriggerName
      setupResourceComponent: -> @component = @resourceComponent
      setupResourceKey: -> @key = @resourceKey

      show: -> @modal.show = true
      close: ->
        @modal.show = false
        @$emit 'close'

      generatePayload: ->
        @modal.data

    watch:
      'modal.show': (value) ->
        @fetchAllResources?({ force: true }) if value

  @mergeConfigs: (cfg1, cfg2) ->
    d = cfg1.data?() || {}
    d[k] = v for k, v of (cfg2.data?() || {})
    data = -> d

    computed = cfg1.computed
    computed[k] = v for k, v of (cfg2.computed || {})

    methods = cfg1.methods
    methods[k] = v for k, v of (cfg2.methods || {})

    watch = cfg1.watch
    watch[k] = v for k, v of (cfg2.watch || {})

    { data, computed, methods, watch }

export default ResourceTrigger